var PlaylistService = (function () {
    function PlaylistService(SCConfiguration, $http) {
        this.$http = $http;
        this.nextGenPlaylistEndpoint = SCConfiguration.getEndpoint() + '/api/nextgen';
    }
    PlaylistService.prototype.fetchTopLevel = function () {
        return this.$http
            .get(this.nextGenPlaylistEndpoint + '/my-top-level')
            .then(function (response) { return response.data; });
    };
    PlaylistService.prototype.fetchChildNodes = function (id) {
        return this.$http
            .get(this.nextGenPlaylistEndpoint + "/child-nodes/".concat(id))
            .then(function (res) { return res.data; });
    };
    PlaylistService.prototype.fetchScoutingReportPlaylists = function (scoutingReportId, playlistIds) {
        return this.$http
            .get(this.nextGenPlaylistEndpoint +
            "/playlists-by-scouting-report/".concat(scoutingReportId, "?playlistIds=").concat(playlistIds))
            .then(function (res) { return res.data.map(function (_a) {
            var playlist = _a.playlist;
            return playlist;
        }); });
    };
    return PlaylistService;
}());
angular.module('app.scouting').service('PlaylistService', PlaylistService);